<template>
    <el-row type="flex" justify="center" align="middle">
        <el-col :xs="22" :sm="22" :md="20" :lg="18" :xl="16">
            <slot />
        </el-col>
    </el-row>
    <!-- <div class="ff">
        <slot></slot>
    </div> -->
</template>

<script setup>
</script>
<style scoped>
</style>